import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "flex-1 flex-col text-gary-text-sub-title-color mt-2.5 sm:mt-0 sm:ml-[50px]" }
const _hoisted_2 = { class: "filter-search mx-[58px] sm:mx-0 flex flex-col sm:flex-row justify-between gap-4 mb-4 sm:mb-[40px]" }
const _hoisted_3 = { class: "sm:w-[442px]" }
const _hoisted_4 = { class: "sm:w-[273px] items-right" }
const _hoisted_5 = { class: "" }
const _hoisted_6 = { class: "hidden sm:block" }
const _hoisted_7 = { class: "sm:hidden px-2.5" }
const _hoisted_8 = { class: "sm:divide-y-[1px] mx-[16px] sm:mx-0 border-black-300-color border-b-[1px] border-b-[1px] sm:border-b-0" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "flex flex-row py-[25px] w-min" }
const _hoisted_11 = { class: "flex flex-col flex-nowrap" }
const _hoisted_12 = { class: "text-[15px] text-light-gary-text-color whitespace-nowrap sm:tracking-[.12em] leading-[20px]" }
const _hoisted_13 = { class: "text-[13px] text-light-gary-text-color tracking-[.12em]" }
const _hoisted_14 = { class: "font-medium text-[0.875rem] whitespace-nowrap text-gary-line-color tracking-[.06em]" }
const _hoisted_15 = { class: "font-medium text-[0.875rem] text-gary-line-color tracking-[.06em]" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "mr-1" }, "NT.", -1)
const _hoisted_17 = { class: "font-medium text-[0.875rem] text-gary-line-color tracking-[.06em]" }
const _hoisted_18 = { class: "pr-[16px] sm:pr-0" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "pt-[30px] sm:pt-[60px] items-center text-center text-sm text-black-400-color" }, " - 您已瀏覽所有資訊 - ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_date_picker = _resolveComponent("date-picker")!
  const _component_SearchInput = _resolveComponent("SearchInput")!
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_SquareItemFullImage = _resolveComponent("SquareItemFullImage")!
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_date_picker, {
          "prefix-class": "xmx",
          value: _ctx.timeRange,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.timeRange) = $event)),
          "disabled-date": _ctx.disabledAfterToday,
          clearable: false,
          placeholder: '請選擇開始時間和結束時間',
          range: ""
        }, null, 8, ["value", "disabled-date"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_SearchInput, {
          getInput: _ctx.getInput,
          "onUpdate:getInput": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.getInput) = $event))
        }, null, 8, ["getInput"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_Tabs, {
          data: _ctx.cartStore.state.purchaseStatusList,
          customClass: 'custom-order-tabs',
          selectedNum: _ctx.selectId,
          onTabSelect: _ctx.tabSelect
        }, null, 8, ["data", "selectedNum", "onTabSelect"]),
        _createVNode(_component_Divider)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_Tabs, {
          data: _ctx.cartStore.state.purchaseStatusList,
          customClass: 'mobile-custom-order-tabs',
          selectedNum: _ctx.selectId,
          onMobileTabSelect: _ctx.mobileTabSelect
        }, null, 8, ["data", "selectedNum", "onMobileTabSelect"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderList, (order) => {
          return (_openBlock(), _createElementBlock("div", {
            key: order.OrderId,
            class: "flex justify-between items-center cursor-pointer",
            onClick: ($event: any) => (_ctx.goOrderDetail(order.OrderId))
          }, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_SquareItemFullImage, {
                width: '80px',
                image: order.OrderItemList[0].CmdyImage.PcWeb,
                class: "sm:hidden mx-[16px]",
                customClass: ''
              }, null, 8, ["image"]),
              _createVNode(_component_SquareItemFullImage, {
                width: '100px',
                image: order.OrderItemList[0].CmdyImage.PcWeb,
                class: "hidden sm:block mx-[40px]",
                customClass: ''
              }, null, 8, ["image"]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.unescapeHTML(order.OrderItemList[0].CmdyName)), 1),
                _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.unescapeHTML(order.OrderItemList[0].CmdySubName)), 1),
                _createElementVNode("div", _hoisted_14, " # " + _toDisplayString(order.OrderId), 1),
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createElementVNode("span", null, _toDisplayString(order.TotalAmount), 1)
                ]),
                _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.moment
                    .utc(_ctx.moment.utc(order.CreateDate, "YYYYMMDDHHmmss").local())
                    .format("YYYY/MM/DD")), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_Icon, {
                iconName: "arrow_right",
                width: '24px'
              })
            ])
          ], 8, _hoisted_9))
        }), 128))
      ]),
      _hoisted_19
    ])
  ]))
}